import { MediaQuery, MediaQueryProps } from 'gocclr-shared-ui/dist/elements/media-query';
import { ExtraLarge, Large, Medium, Small } from '../../styles/bootstrap-breakpoints';

export type BoostrapMediaQueryProps = Omit<MediaQueryProps, 'query'>;

type BoostrapMediaQueryBaseProps = BoostrapMediaQueryProps & {
    breakpoint: number;
    attributeToCompate: 'max-width' | 'min-width';
};

function BoostrapBaseMediaQuery(props: BoostrapMediaQueryBaseProps) {
    const { children, breakpoint, attributeToCompate, ...rest } = props;
    const query = `(${attributeToCompate}: ${breakpoint}px)`;

    return (
        <MediaQuery query={query} {...rest} >
            {children}
        </MediaQuery>
    );
}

export function ExtraSmallMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={Small} attributeToCompate='max-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}

export function SmallMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={Small} attributeToCompate='min-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}

export function MediumMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={Medium} attributeToCompate='min-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}

export function LargeMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={Large} attributeToCompate='min-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}

export function ExtraLargeMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={ExtraLarge} attributeToCompate='min-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}

export function ExtraExtraLargeXlMediaQuery(props: BoostrapMediaQueryProps) {
    const { children, ...rest } = props;

    return (
        <BoostrapBaseMediaQuery breakpoint={ExtraLarge} attributeToCompate='min-width' {...rest} >
            {children}
        </BoostrapBaseMediaQuery>
    );
}